import { render, staticRenderFns } from "./BlacklistRede.vue?vue&type=template&id=2cb15c4e"
import script from "./BlacklistRede.vue?vue&type=script&lang=js"
export * from "./BlacklistRede.vue?vue&type=script&lang=js"
import style0 from "./BlacklistRede.vue?vue&type=style&index=0&id=2cb15c4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports